import { STORE_BOOK } from '../types/type';

const initState = {
    book: []
}

const BookReducer = (state = initState, action) => {
    switch (action.type) {
        case STORE_BOOK:
            return {
                ...state,
                book: action.payload
            }

        default:
            return state;
    }
}

export default BookReducer;